import { routes } from "src/routes";
import { featureType } from "../../types/Feature";
import useTranslateFeature from "../../utils/translateFeature";
import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
interface NavigationCardProps {
  feature: featureType;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
}

export default function NavigationCard({
  feature,
  setIsMenuOpen,
}: NavigationCardProps) {
  const navigate = useNavigate();
  const { companyId, deviationId, inspectionId } = useParams();
  const params = useParams();
  const translatedFeature = useTranslateFeature(feature);

  const handleClick = () => {
    if (feature.name === "deviation") {
      navigate(routes.Deviation.Pages.List.url(companyId!));
    } else if (
      feature.name === "Egenkontroller" ||
      feature.name === "Inspection"
    ) {
      navigate(routes.Egenkontroller.Pages.List.url(companyId!));
    } else if (translatedFeature.path) {
      try {
        navigate(translatedFeature.path);
      } catch (error) {
        console.error("Navigation failed:", error);
      }
    } else if (feature.path) {
      try {
        let path = feature.path;
        Object.entries(params).forEach(([key, value]) => {
          path = path.replace(`:${key}`, value as string);
        });
        navigate(path);
      } catch (error) {
        console.error("Failed to open URL:", error);
      }
    } else if (feature.url) {
      try {
        window.open(feature.url, "_blank");
      } catch (error) {
        console.error("Failed to open URL:", error);
      }
    } else {
    }
    setTimeout(() => {
      setIsMenuOpen(false);
    }, 100);
  };
  const isFeatureNavigatedTo = useMemo(() => {
    return (
      !!(
        (feature.name as string).toLowerCase() === "deviation" &&
        location.pathname.startsWith(
          routes.Deviation.Pages.List.url(companyId!)
        )
      ) ||
      !!(
        ((feature.name as string) === "Egenkontroller" ||
          (feature.name as string) === "Inspection") &&
        location.pathname.startsWith(
          routes.Egenkontroller.Pages.List.url(companyId!)
        )
      ) ||
      false
    );
  }, [feature.name, companyId, translatedFeature.path, feature.url]);

  return (
    <button
      onClick={handleClick}
      id={`navigation-card-${feature.name}`}
      style={{
        width: "100%",
        margin: 0,
        backgroundColor: isFeatureNavigatedTo ? "#ddd" : "#ffffff",
        padding: "20px 24px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
        border: "2px solid #e0e0e0",
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
      }}
    >
      <div style={{ width: "10%" }}>
        {translatedFeature.icon && (
          <i
            className={`fa-solid fa-${translatedFeature.icon} text-PrimaryGreen text-2xl `}
          />
        )}
      </div>

      <div style={{ width: "90%" }}>
        <span
          style={{
            color: "PrimaryGreen",
            fontSize: 20,
            fontWeight: "700",
            textAlign: "center",
            letterSpacing: 0.5,
            marginBottom: 0,
          }}
          className="text-PrimaryGreen"
        >
          {translatedFeature.name}
        </span>
      </div>
    </button>
  );
}
